import { c as _c } from "react/compiler-runtime";
import { FaroTextButton } from "@components/common/faro-text-button";
import { Box } from "@mui-wrapper";
import { Tooltip } from "@flat-ui";
import { DEFAULT_TITLE_FONT_SIZE, withEllipsis } from "@styles/common-styles";
import { PALETTE_VARS } from "@styles/palette-vars";
import { HEADER_HEIGHT } from "@utils/ui-utils";
/**
 * A custom button that can be used in the left side of the header
 * It has a tooltip and an icon on the left side of the text, together with appropriate borders
 */
export function HeaderLayoutLeftButton(t0) {
  const $ = _c(14);
  const {
    onClickHandler,
    navigationTo,
    icon,
    text,
    tooltip
  } = t0;
  const Icon = icon;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      height: `calc(${HEADER_HEIGHT} - 1px)`,
      ml: {
        xs: -2,
        sm: -3
      },
      px: 3,
      borderRadius: "0px",
      color: "text.primary",
      borderRight: `1px solid ${PALETTE_VARS.divider}`
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== Icon) {
    t2 = Icon && <Icon sx={{
      width: "16px"
    }} />;
    $[1] = Icon;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      ml: "10px",
      fontSize: DEFAULT_TITLE_FONT_SIZE,
      ...withEllipsis
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== text) {
    t4 = <Box component="span" sx={t3}>{text}</Box>;
    $[4] = text;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== navigationTo || $[7] !== onClickHandler || $[8] !== t2 || $[9] !== t4) {
    t5 = <FaroTextButton sx={t1} to={navigationTo} onClick={onClickHandler} dataTestId="header-left-button">{t2}{t4}</FaroTextButton>;
    $[6] = navigationTo;
    $[7] = onClickHandler;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5 || $[12] !== tooltip) {
    t6 = <Tooltip component="div" title={tooltip}>{t5}</Tooltip>;
    $[11] = t5;
    $[12] = tooltip;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}